import React from 'react';
import { Text } from '@fragments';
import { IconCheck, IconPhotoPlus, IconSparkles } from '@tabler/icons-react';
import { choiceLabel, choiceThumb, isChosen } from '../../format';
import './styles.scss';

// ↑/↓ (and Home/End) move between the places.
const placeKeys = event => {
  const rows = [...event.currentTarget.querySelectorAll('button')];
  const at = rows.indexOf(document.activeElement);
  if (at < 0) return;
  const to = { ArrowDown: at + 1, ArrowUp: at - 1, ArrowRight: at + 1, ArrowLeft: at - 1, Home: 0, End: rows.length - 1 }[event.key];
  if (to === undefined) return;
  event.preventDefault();
  const row = rows[Math.max(0, Math.min(rows.length - 1, to))];
  row.focus();
  row.click();
};

// The places of the question, in page order: their number, "Página N" and what it is (a
// photo, a frame, the background), the AI's subject, and what will happen to it, over the
// picked image. A place still to answer says so in the brand's colour, over an empty tile; an
// answered one carries a check; a place to generate shows the AI mark.
export default function PlaceList({ t, places, choices, selectedId, onSelect }) {
  return <ol className="studio-image-places" aria-label={t('imagesPlaces', { count: places.length })} onKeyDown={placeKeys}>
    {places.map((place, index) => {
      const choice = choices[place.slot_id];
      const on = place.slot_id === selectedId;
      const chosen = isChosen(place, choice);
      const thumb = choiceThumb(place, choice);
      const generating = choice?.source === 'generate';
      return <li key={place.slot_id}>
        <button type="button" className={`studio-image-places__row ${on ? 'is-active' : ''} ${chosen ? 'is-done' : 'is-pending'}`} aria-current={on ? 'true' : undefined}
          tabIndex={on ? 0 : -1} onClick={() => onSelect(place.slot_id)}>
          <span className={`studio-image-places__thumb ${generating ? 'is-ai' : ''}`} aria-hidden="true">
            {generating ? <IconSparkles /> : thumb ? <img src={thumb} alt="" draggable={false} /> : <IconPhotoPlus />}
            {chosen && <span className="studio-image-places__check"><IconCheck /></span>}
          </span>
          <span className="studio-image-places__text">
            <Text.caption contrast={6}>{`${index + 1}. ${t('imagesPage', { number: place.page })} · ${t(`imagesPlacement_${place.placement}`)}`}</Text.caption>
            <Text.label className="studio-image-places__subject" contrast={9}>{place.subject}</Text.label>
            <Text.caption className="studio-image-places__status" contrast={chosen ? 7 : 9}>{choiceLabel(t, place, choice)}</Text.caption>
          </span>
        </button>
      </li>;
    })}
  </ol>;
}
